import { render } from "./BottomTabBarProp.vue?vue&type=template&id=205da97c&scoped=true"
import script from "./BottomTabBarProp.vue?vue&type=script&lang=js"
export * from "./BottomTabBarProp.vue?vue&type=script&lang=js"

import "./BottomTabBarProp.vue?vue&type=style&index=0&id=205da97c&scoped=true&lang=less"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-205da97c"]])

export default __exports__